export const loginImagePad =
  "https://cdn.protonsystem.io/%E4%B8%89%E6%98%9FPAD%20%208001280%20p2.png";
export const loginImageIphone678 =
  "https://cdn.protonsystem.io/6%28s%29-7-8%20%20%20%207501334%E2%80%93%20P2.png";
export const loginImageIphone678P =
  "https://cdn.protonsystem.io/6%28s%29P-7P-8P%20%C2%A010801920%20P2.png";
export const loginImageIphonex =
  "https://cdn.protonsystem.io/x%28s%29%20%2011252436%20P2.png";
export const loginImageIphonexr =
  "https://cdn.protonsystem.io/xr%20%C2%A08281792%20P2.png";
export const loginImageIphonexsMax =
  "https://cdn.protonsystem.io/xs-Max%20%C2%A0%20%C2%A012422688%20P2.png";
export const yamimealLogo =
  "https://cdn.protonsystem.io/default1.png?imageView2/2/w/250";

export enum deviceWidth {
  Iphone678P = 1242,
  Iphone678 = 750,
  Iphonex = 1125,
  Iphonexr = 828
}
